module.exports = __webpack_public_path__ + "img/image54.d6629131.png";